<template>
  <div class="alert alert-warning-outline border-warning my-3">
    <h3 class="text-uppercase font-condensed d-flex align-items-center">
      <b-img :src="assetServer + '/assets/img/icons/alert.svg'" height="28" class="mr-2" /><slot name="title">{{ "warning" | translate(labels, 'WarningAlert') }}</slot>
    </h3>
    <slot name="body" />
  </div>
</template>

<script>
export default {
  conceptName: ['WarningAlert']
}
</script>

<style lang="scss">
.alert-warning-outline {
  line-height: 1.2rem;
}
</style>
